//TODO: move to backend or change statuses in styled components

type SphereLevel = "CRITICAL" | "MIDDLE" | "HIGH" | "RESOURCE";

type Status = "danger" | "warning" | "success" | "neutral";

//TODO: rename
export const sphereLevelToStatus: Record<SphereLevel, Status> = {
  CRITICAL: "danger",
  MIDDLE: "warning",
  HIGH: "success",
  RESOURCE: "success",
};

type ScalesLevel =
  | "neutral"
  | "low"
  | "belowMedium"
  | "medium"
  | "aboveMedium"
  | "high";

export const scaleLevelToStatus: Record<ScalesLevel, Status> = {
  neutral: "neutral",
  low: "success",
  belowMedium: "success",
  medium: "warning",
  aboveMedium: "danger",
  high: "danger",
};

export const resolveSliceStatus = (type: string, level: ScalesLevel) => {
  if (type === "posttraumatic-growth") {
    return "success";
  }

  if (type === "rse") {
    return level === "high" ? "warning" : scaleLevelToStatus[level];
  }

  return scaleLevelToStatus[level];
};

export const getStatusFromSphereLevel = (
  level: string | undefined | null,
): Status | undefined => {
  if (!level) return undefined;

  if (level in sphereLevelToStatus) {
    return sphereLevelToStatus[level as SphereLevel];
  }

  return undefined;
};

export const getDynamicsStatus = (dynamics: unknown) => {
  const isNumber = typeof dynamics === "number" && !isNaN(dynamics);
  if (!isNumber) return "neutral";
  if (dynamics === 0) return "neutral";
  if (dynamics > 0) return "success";
  if (dynamics < 0) return "danger";
};
